export default __webpack_public_path__ + "static/media/user_card.458010d5.png";